import styled from '@emotion/styled'

import { SubtlePushIcon } from '@arcade/web/icons/react'
import { Flex, PaddingInset, spacing } from '@cash-design-system/react'
import { FormBlockerElementDetailRowElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import logger from '@cash-web/shared/util-logger'
import { useTextTokenizer } from '@cash-web/shared-feature-use-text-tokenizer'
import { useFlowContext } from '@cash-web/shared-flow-data-access-context'

const TitleAction = styled.div<{ enableHoverStyles: boolean }>`
  ${({ enableHoverStyles, theme }) => {
    if (enableHoverStyles) {
      return `&:hover {
        cursor: pointer;
        color: ${theme.colors.textButtonLabelHover};
      `
    }
    return ''
  }}
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: ${spacing.xl};
`

const Details = styled.div`
  text-align: right;
`

export const DetailRowElement = ({
  title,
  subtitle,
  detail_text,
  title_action,
}: FormBlockerElementDetailRowElement) => {
  const textTokenizer = useTextTokenizer()
  const flow = useFlowContext()

  function handleTitleAction() {
    if (title_action) {
      flow.executeBlockerAction(title_action)
    }
  }

  const enableTitleAction = Boolean(title_action && title)
  if (title_action && !title) {
    logger.error(new Error('DetailRowElement: title_action not applied because there is no title'))
  }

  let titleActionProps
  if (enableTitleAction) {
    titleActionProps = {
      role: 'button',
      onClick: handleTitleAction,
      tabIndex: 0,
    }
  }

  return (
    <PaddingInset>
      <Grid>
        <TitleAction enableHoverStyles={enableTitleAction} {...titleActionProps}>
          {title && (
            <Flex alignItems="center" gap="0.125rem">
              {textTokenizer(title)} {title_action && <SubtlePushIcon />}
            </Flex>
          )}
          {subtitle && <div>{textTokenizer(subtitle)}</div>}
        </TitleAction>
        <Details>{detail_text && textTokenizer(detail_text)}</Details>
      </Grid>
    </PaddingInset>
  )
}
